import React from 'react';
// @ts-ignore
import styles from './RemoveConfirmation.module.scss';
import Button from '../Button/Button';
import { useAppContext } from '../../Services/AppContext';
import { Theme } from '../../Enums/Theme.enum';
import Text from '../Base/Text/Text';
import NoEscape from '../NoEscape';

interface RemoveConfirmationProps {
	onConfirm?: () => void;
	onAbort?: () => void;
	confirmationText?: string;
	customButtons?: (
		handleAbortRemoval: () => void,
	) => React.ReactNode | React.ReactNode[];
	showAbort?: boolean;
}

export default function RemoveConfirmation(props: RemoveConfirmationProps) {
	const {
		onConfirm,
		onAbort,
		confirmationText = 'base.deleteConfirmationDefaultText',
		customButtons,
		showAbort = true,
	} = props;

	// @ts-ignore
	const handleConfirmRemove = () => {
		onConfirm && onConfirm();
	};

	const handleAbortRemoval = () => {
		onAbort && onAbort();
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				<div className={styles.text}>
					<Text tx={confirmationText} inline={true} firstUpper noEscape />
				</div>
			</div>
			<div className={styles.controls}>
				{showAbort && (
					<Button
						onClick={handleAbortRemoval}
						title={'base.no'}
						theme={Theme.RED}
					/>
				)}
				{!customButtons ? (
					<Button
						onClick={handleConfirmRemove}
						title={'base.yes'}
						theme={Theme.GREEN}
					/>
				) : (
					customButtons(handleAbortRemoval)
				)}
			</div>
		</div>
	);
}
